const RICOS_VERSION = "10.175.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
